const url = "https://shop-commerce.onrender.com";

export default url;
